module.exports = __webpack_public_path__ + "img/loading-icon.9e0373c2.gif";